import { render, staticRenderFns } from "./ResumoAnaliticoDePonto.vue?vue&type=template&id=c52f8ac8"
import script from "./ResumoAnaliticoDePonto.vue?vue&type=script&lang=js"
export * from "./ResumoAnaliticoDePonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports